"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Copyright 2017-2022 @darwinia/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
// order important in structs... :)

/* eslint-disable sort-keys */
var _default = {
  rpc: {},
  types: {
    BSCHeader: {
      parentHash: 'H256',
      uncleHash: 'H256',
      coinbase: 'EthereumAddress',
      stateRoot: 'H256',
      transactionsRoot: 'H256',
      receiptsRoot: 'H256',
      logBloom: 'Bloom',
      difficulty: 'U256',
      number: 'u64',
      gasLimit: 'U256',
      gasUsed: 'U256',
      timestamp: 'u64',
      extraData: 'Bytes',
      mixDigest: 'H256',
      nonce: 'Bytes'
    }
  }
};
exports.default = _default;